import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import { MediaModel } from '../media.model';
import { isNullOrWhitespace } from '../functions';
import { Globals } from '../globals';
import { WalletStats, WalletTemplateModel } from '../wallet-template.model';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';
import { AppleWalletPassStyle, GoogleWalletPassStyle } from '../wallet-passstyle-enum';
import { DOCUMENT } from '@angular/common';
import { TranslationService } from 'src/app/shared/translation.service';
import { WalletBarcodeType } from '../wallet-barcode-type.enum';
import { DomSanitizer } from '@angular/platform-browser';
import { WalletTemplateField } from '../wallet-template-field.model';
import { DataType, WalletAppleField, WalletGoogleField, WalletTemplateDataSource } from '../wallet-template-enums';
import { CompanyViewModel } from '../../setting/company/company-view.model';


@Component({
    selector: 'hc-digital-card-google',
    templateUrl: './digital-card-google.component.html',
    styleUrls: ['./digital-card-google.component.scss']
})

export class DigitalCardGoogleComponent implements OnInit {
    walletBarcodeType = WalletBarcodeType;
    WalletGoogleField = WalletGoogleField;
    GoogleWalletPassStyle = GoogleWalletPassStyle;
    private _googleWalletFields: WalletTemplateField[] = [];

    @Input() public mediaModel: MediaModel;
    @Input() public walletTemplate: WalletTemplateModel;
    @Input() public voucherTemplate: Honeycomb.Tenant.Vouchers.IService.Model.VoucherTemplate;
    @Input() fieldErrors: Record<string, boolean> | null = null;

    @Input() googleImageUrl: string | null = null;
    @Input() googleLogoUrl:  string | null = null;
    @Input() showBackSide = false;
    @Input() showContent: boolean = true;
    @Input() activeCompany: CompanyViewModel | null = null;

    @Input()
    set googleWalletFields(value: WalletTemplateField[]) {
        this._googleWalletFields = value ?? [];
        this.editingPos = null;
        this.cd.markForCheck();
    }
    get googleWalletFields(): WalletTemplateField[] {
        return this._googleWalletFields;
    }
    @Output() googleWalletFieldsChange = new EventEmitter<WalletTemplateField[]>();
    @Output() googleFieldSelected = new EventEmitter<WalletGoogleField | null>();


    activePos: WalletGoogleField | null = null;
    editingPos: WalletGoogleField | null = null;
    private editingCell?: HTMLElement | null;

    public rowCnt = 0;

    public googleStyle: string;

    showRow2 = false;
    showRow3 = false;

    readonly genericTopHeaderCells = [
        WalletGoogleField.TopRowSubheader,
        WalletGoogleField.TopRowHeader
    ];

    private readonly singleValueFields = new Set<WalletGoogleField>([
        WalletGoogleField.IssuerName,
        WalletGoogleField.ProgramName,
        WalletGoogleField.LoyaltyPoints,
        WalletGoogleField.SecondaryLoyaltyPoints,
        WalletGoogleField.TopRowSubheader,
        WalletGoogleField.TopRowHeader,
        WalletGoogleField.LocalizedTitle,
        WalletGoogleField.BarcodeValue
    ]);

    @HostListener('document:keydown.escape', ['$event'])
    handleEsc(_event: KeyboardEvent) {
        this.resetSelection();
    }

    @HostListener('document:click', ['$event'])
    handleDocumentClick(event: MouseEvent) {
        const target = event.target as Node | null;
        if (!target) {
            return;
        }

        const host = this.elementRef?.nativeElement as HTMLElement | null;
        const targetElement = target instanceof Element
            ? target
            : (target.parentElement as Element | null);

        if (!targetElement) {
            this.handleClickAway();
            return;
        }

        if (host?.contains(target)) {
            if (targetElement.closest('.cell')) {
                return;
            }

            this.handleClickAway();
            return;
        }

        this.handleClickAway();
    }

    private _globals: Globals;
    get getGlobals() {
        return this._globals;
    }

    private _sanitizer: DomSanitizer;
    get getSanitizer() {
        return this._sanitizer;
    }

    constructor(
        private globals: Globals,
        private sanitizer: DomSanitizer,
        private trans: TranslationService,
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this._globals = globals;
        this._sanitizer = sanitizer;
    }

    async ngOnInit() {
        //this.logoSrc = await this.getImage(this.mediaModel.walletGoogleLogoUID);
        this.googleStyle = GoogleWalletPassStyle[this.walletTemplate.walletStyle];
        //TODO -> Set row count acording to input data --default = 1
        //this.rowCnt
    }

    ngOnChanges(): void {
        this.recalcVisibleRowsFromData();
    }
    

    getImagePath(imgName: string): string {
        const baseUrl = this.document.baseURI;
        return `${baseUrl}img/${imgName}.png`;
    }

    getBarcodePreviewPath(): string | null {
        switch (this.mediaModel?.walletBarcodeType) {
            case WalletBarcodeType.QRCode:
                return 'wallet_qr';
            case WalletBarcodeType.PDF417:
                return 'wallet_pdf417';
            case WalletBarcodeType.Aztec:
                return 'wallet_aztec';
            case WalletBarcodeType.Code128:
                return 'wallet_code128';
            default:
                return null;
        }
    }

    onRowClick(ev: MouseEvent): void {
        ev.stopPropagation();

        const target = ev.target as HTMLElement | null;
        if (!target) {
            return;
        }
        const cell = target.closest('.cell') as HTMLElement | null;
        if (!cell) {
            return;
        }
        const posAttr = cell.getAttribute('data-pos');
        if (!posAttr) {
            return;
        }
        const pos = Number(posAttr) as WalletGoogleField;

        if (this.editingCell && this.editingCell !== cell) {
            this.trySaveActiveEdit();
        }

        this.activePos = pos;
        this.editingPos = pos;
        this.editingCell = cell;
        this.googleFieldSelected.emit(pos);
    }

    onCellFocusIn(pos: WalletGoogleField, cellRef: HTMLElement, ev: Event) {
        this.editingCell = cellRef;
        this.googleFieldSelected.emit(pos);
    }

    onSpecialFieldClick(pos: WalletGoogleField, ev: MouseEvent): void {
        ev.stopPropagation();

        const targetCell = ev.currentTarget instanceof HTMLElement ? ev.currentTarget : null;
        if (this.editingCell && targetCell && this.editingCell !== targetCell) {
            this.trySaveActiveEdit();
        }

        this.activePos = pos;
        this.editingPos = pos;
        this.editingCell = targetCell;
        this.googleFieldSelected.emit(pos);
    }

    onSpecialFieldEnter(pos: WalletGoogleField, value: string): void {
        const nextValue = value?.trim();

        if (!nextValue) {
            this.resetSelection();
            return;
        }

        const existing = this.getFieldByPosition(pos);
        const label = existing?.label || this.getSpecialFieldLabel(pos);

        if (existing) {
            const updatedField = this.createUpdatedField(existing, pos, label, nextValue);
            this.googleWalletFields = (this.googleWalletFields ?? []).map(f => f === existing ? updatedField : f);
        } else {
            const field = this.createDefaultField(pos, label, nextValue);
            this.googleWalletFields = [...(this.googleWalletFields ?? []), field];
        }

        this.googleWalletFieldsChange.emit(this.googleWalletFields);
        this.resetSelection();
    }

    lowercaseFirstLetter(val) {
        return String(val).charAt(0).toLowerCase() + String(val).slice(1);
    }

    getActualFieldValue(field: WalletTemplateField): string {
        let value = null;
        let sourceField = this.lowercaseFirstLetter(field.sourceField);
        if(field.dataSource === WalletTemplateDataSource.Media) {
            value = this.mediaModel?.[sourceField as keyof MediaModel] as string || '';
        }

        return value;
    }

    getSpecialFieldValue(pos: WalletGoogleField): string {
        const field = this.getFieldByPosition(pos);
        if (!field) {
            return '';
        }

        let value = this.getActualFieldValue(field);

        return value || field.defaultValueSourceField || '';
    }

    getSpecialFieldLabel(pos: WalletGoogleField): string {
        switch (pos) {
            case WalletGoogleField.IssuerName:
                return 'issuer name';
            case WalletGoogleField.ProgramName:
                return 'program name';
            case WalletGoogleField.LoyaltyPoints:
                return 'loyalty points';
            case WalletGoogleField.SecondaryLoyaltyPoints:
                return 'secondary loyalty points';
            case WalletGoogleField.TopRowSubheader:
                return 'top row subheader';
            case WalletGoogleField.TopRowHeader:
                return 'top row header';
            case WalletGoogleField.LocalizedTitle:
                return 'title';
            case WalletGoogleField.BarcodeValue:
                return 'barcode text';
            default:
                return '';
        }
    }

    getBackSideFields(): WalletTemplateField[] {
        return (this.googleWalletFields ?? [])
            .filter(f => f.googleField === WalletGoogleField.TextModulesData)
            .sort((a, b) => (a.fieldOrder ?? 0) - (b.fieldOrder ?? 0));
    }

    clearCell(pos: WalletGoogleField, ev?: MouseEvent): void {
        ev?.stopPropagation();

        this.googleWalletFields = (this.googleWalletFields ?? []).filter(f => f.googleField !== pos);
        this.activePos = pos;
        this.editingPos = pos;
        this.editingCell = null;
        this.googleWalletFieldsChange.emit(this.googleWalletFields);
        this.googleFieldSelected.emit(pos);
    }

    public getFieldByPosition(pos: WalletGoogleField): WalletTemplateField | null {
        return this.googleWalletFields.find(f => f.googleField === pos) ?? null;
    }

    //Row handling
    private rowHasAnyField(rowIndex: number): boolean {
        if (!this.googleWalletFields) {
            return false;
        }

        const rowPositions: WalletGoogleField[][] = [
            [WalletGoogleField.Row1Left,  WalletGoogleField.Row1Middle,  WalletGoogleField.Row1Right],
            [WalletGoogleField.Row2Left,  WalletGoogleField.Row2Middle,  WalletGoogleField.Row2Right],
            [WalletGoogleField.Row3Left,  WalletGoogleField.Row3Middle,  WalletGoogleField.Row3Right],
        ];

        const positions = rowPositions[rowIndex];
        return this.googleWalletFields.some(f => positions.includes(f.googleField));
    }

    private recalcVisibleRowsFromData(): void {
        this.showRow2 = this.rowHasAnyField(1);
        this.showRow3 = this.rowHasAnyField(2);
    }

    // handler pro plus tlačítko
    addRow(afterRow: number): void {
        if (afterRow === 1) {
            this.showRow2 = true;
        } else if (afterRow === 2) {
            this.showRow3 = true;
        }
    }

    startEditKey(pos: WalletGoogleField): void {
        this.editingPos = pos;
    }

    isCellActive(pos: WalletGoogleField): boolean {
        return this.isEditing(pos);
    }

    isEditing(pos: WalletGoogleField): boolean {
        return this.editingPos === pos;
    }

    hasFieldError(fieldKey: string): boolean {
        return !!this.fieldErrors?.[fieldKey];
    }

    onCellEnter(pos: WalletGoogleField, header: string, value: string): void {
        const h = header?.trim();
        const v = value?.trim();

        if (!h || !v) {
            this.resetSelection();
            return;
        }
        const field = this.createDefaultField(pos, h, v, h);
        const withoutSamePos = (this.googleWalletFields ?? [])
            .filter(g => g.googleField !== pos);

        this.googleWalletFields = [...withoutSamePos, field];
        this.googleWalletFieldsChange.emit(this.googleWalletFields);
        this.resetSelection();
    }

    private createDefaultField(
        pos: WalletGoogleField,
        header: string,
        value: string,
        defaultValueLabelOverride?: string,
    ): WalletTemplateField {
        return {
            walletTemplateFieldID: 0,
            walletTemplateID: this.walletTemplate?.walletTemplateID ?? 0,
            fieldOrder: 0,
            dataType: DataType.Text,
            dataSource: WalletTemplateDataSource.None,
            label: header,
            sourceField: '',
            labelDataSource: WalletTemplateDataSource.None,
            defaultValueDataSource: WalletTemplateDataSource.None,
            defaultValueSourceField: value,
            defaultValueLabel: defaultValueLabelOverride ?? header,
            defaultValueLabelDataSource: WalletTemplateDataSource.None,
            appleField: WalletAppleField.Undefined,
            googleField: pos,
            changeMessage: '',
            googleClassVariantField: false,
            created: new Date()
        } as WalletTemplateField;
    }

    private createUpdatedField(existing: WalletTemplateField, pos: WalletGoogleField, header: string, value: string): WalletTemplateField {
        return {
            ...existing,
            googleField: pos,
            label: header,
            sourceField: '',
            defaultValueSourceField: value,
            defaultValueLabel: header,
        } as WalletTemplateField;
    }

    onCellEscape(_pos: WalletGoogleField, _cellRef: HTMLElement, _ev: KeyboardEvent): void {
        this.resetSelection();
    }

    onEscPressed() {
        this.resetSelection();
    }

    private resetSelection(): void {
        this.activePos = null;
        this.editingPos = null;
        this.editingCell = null;
        this.googleFieldSelected.emit(null);
    }

    private clearEditingOnly(): void {
        this.editingPos = null;
        this.editingCell = null;
    }

    private handleClickAway(): void {
        if (this.trySaveActiveEdit()) {
            return;
        }

        this.clearEditingOnly();

        if (this.activePos != null) {
            this.googleFieldSelected.emit(this.activePos);
        }
    }

    private trySaveActiveEdit(): boolean {
        if (this.editingPos == null || !this.editingCell) {
            return false;
        }

        const singleValueInput = this.editingCell.querySelector('input[data-field="single-value"]') as HTMLInputElement | null;
        if (singleValueInput && this.singleValueFields.has(this.editingPos)) {
            const value = singleValueInput.value?.trim();
            if (isNullOrWhitespace(value)) {
                return false;
            }

            this.onSpecialFieldEnter(this.editingPos, value);
            return true;
        }

        const headerInput = this.editingCell.querySelector('input[data-field="header"]') as HTMLInputElement | null;
        const valueInput = this.editingCell.querySelector('input[data-field="value"]') as HTMLInputElement | null;

        if (!headerInput || !valueInput) {
            return false;
        }

        const header = headerInput.value?.trim();
        const value = valueInput.value?.trim();

        if (isNullOrWhitespace(header) || isNullOrWhitespace(value)) {
            return false;
        }

        this.onCellEnter(this.editingPos, header, value);
        return true;
    }

    trackByItem = (_: number, v: string) => v;
}
